import { HistoriaClinica } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroHistoriaClinicaState extends CommonState<HistoriaClinica> {
    current: HistoriaClinica | undefined;

    isLoadingByPaciente: boolean;
    successLoadingByPaciente: boolean | undefined;
    failOnLoadingByPaciente: boolean;

    isCreating: boolean;
    successCreating: boolean | undefined;
    failOnCreating: boolean;
}

export const TurneroHistoriaClinicaUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    current: undefined,

    isLoadingByPaciente: false,
    successLoadingByPaciente: undefined,
    failOnLoadingByPaciente: false,

    isCreating: false,
    successCreating: undefined,
    failOnCreating: false
};
